import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_proto_theme_demo: FaireCategoryEntity = {
  token: "cat_proto_theme-demo",
  type: "category",
  name: "Theme Demo",
  level: 1,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
